import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Utils } from '../utils/utils';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from "./url.service";

@Injectable({
  providedIn: 'root'
})

export abstract class PageStyleBaseService extends GenericBaseService {

  imageBlobUrl: any;

  constructor(
    subject: string,
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super(subject, httpClient, toastrService, url);
  }

  private createImageFromBlob(imageAsBlob: Blob, afterGetCallback?: (result: string | ArrayBuffer) => void) {
    let reader = new FileReader();
    reader.addEventListener('load', () => {
      this.imageBlobUrl = reader.result;
      if (afterGetCallback) {
        afterGetCallback(reader.result);
      }
    }, false);

    if (imageAsBlob) {
      reader.readAsDataURL(imageAsBlob);
    }
  }

  getImage(url: string, authorizationCode: string, afterGetCallback?: (result: string | ArrayBuffer) => void, allowNoAuth = false): void {
    this.imageBlobUrl = null;
    let httpHeaders: HttpHeaders = null;

    if (allowNoAuth === true) {
      httpHeaders = this.buildHttpHeaders(allowNoAuth);
    }

    const options = {
      headers: httpHeaders,
      responseType: 'blob' as 'json'
    };

    const apiUrl = this.getApiUrl(url + '/' + authorizationCode);
    this.httpClient.get<any>(apiUrl, options)
      .subscribe(
        (data: any) => {
          if (data) {
            this.createImageFromBlob(data, afterGetCallback);
          } else {
            afterGetCallback(null);
          }
        },
        error => {
          Utils.handleError(this.toastrService, error);
        });
  }

  /**
   * @param afterCompleteCallback Runs whether the upload succeeded or failed, for callers that need to
   *                              know the request is no longer in flight.
   */
  saveImage(url: string, companyId: number, fileToUpload: File, afterSaveCallback?: Function, customMessage?: string,
            afterCompleteCallback?: Function) {
    const formData: FormData = new FormData();
    formData.append('fileKey', fileToUpload, fileToUpload.name);

    this.httpClient.post(this.getApiUrl(url + '/' + companyId), formData)
      .subscribe(() => {
          if (afterSaveCallback) {
            afterSaveCallback();
          }

          if (customMessage) {
            this.toastrService.success(customMessage);
          } else {
            this.toastrService.success('Image ' + fileToUpload.name + ' uploaded successfuly');
          }

          if (afterCompleteCallback) {
            afterCompleteCallback();
          }
        },
        error => {
          Utils.handleError(this.toastrService, error);

          if (afterCompleteCallback) {
            afterCompleteCallback();
          }
        });
  }

  /**
   * @param afterCompleteCallback Runs whether the delete succeeded or failed, for callers that need to
   *                              know the request is no longer in flight.
   */
  deleteImage(url: string, companyId: number, fileName: string, afterDeleteCallback?: Function, customMessage?: string,
              afterCompleteCallback?: Function) {
    this.httpClient.delete(this.getApiUrl(url + '/' + companyId))
      .subscribe(
        () => {
          if (customMessage) {
            this.toastrService.info(customMessage);
          } else {
            this.toastrService.info('Image ' + fileName + ' is deleted');
          }

          if (afterDeleteCallback) {
            afterDeleteCallback();
          }

          if (afterCompleteCallback) {
            afterCompleteCallback();
          }
        },
        error => {
          Utils.handleError(this.toastrService, error);

          if (afterCompleteCallback) {
            afterCompleteCallback();
          }
        });
  }
}
